export interface PresetComponentData {
  id: number;
  compValues: number[];
  classUnit: string;
}

export default class PresetComponentVO {
  private idValue: number;
  private propertyValue: string;
  private compValuesValue: number[];
  private classUnitValue: string;
  private classPrefixNameValue: string;
  private classPresetCompDelimiterValue: string;
  private classNameValue?: string;

  constructor(property: string, id: number, compValues: number[], classUnit: string) {
    this.idValue = id;
    this.propertyValue = property;
    this.compValuesValue = compValues;
    this.classUnitValue = classUnit;
    this.classPrefixNameValue = 'comp';
    this.classPresetCompDelimiterValue = '-';
  }

  get id(): number {
    return this.idValue;
  }

  set id(id: number) {
    this.idValue = id;
  }

  get property(): string {
    return this.propertyValue;
  }

  set property(value: string) {
    this.propertyValue = value;
  }

  get compValues(): number[] {
    return this.compValuesValue;
  }

  set compValues(value: number[]) {
    this.compValuesValue = value;
  }

  get classUnit(): string {
    return this.classUnitValue;
  }

  set classUnit(value: string) {
    this.classUnitValue = value;
  }

  get className(): string | undefined {
    return this.classNameValue;
  }

  set className(className: string | undefined) {
    this.classNameValue = className;
  }

  getClassName(): string {
    return this.classPrefixNameValue + this.classPresetCompDelimiterValue + this.compValuesValue.join(this.classPresetCompDelimiterValue);
  }

  getComponentMarkup(numberOfDivisionsInComponent: number): string {
    const compMarkup = `<div class="preset-comp"></div>`;
    let markup = '';
    for (let i = 0; i < numberOfDivisionsInComponent; i++) {
      markup += compMarkup;
    }
    return markup;
  }

  render(selectedPresetID: number): string {
    if (selectedPresetID === this.idValue) {
      this.classNameValue = this.getClassName() + ' -selected';
    } else {
      this.classNameValue = this.getClassName();
    }

    return `<div class="preset-wrapper js-comp-preset ${this.classNameValue}" data-preset-id="${this.idValue}">
               ${this.getComponentMarkup(this.compValues.length)}
                </div>`;
  }

  toObject(): PresetComponentData {
    return {
      id: this.id,
      compValues: this.compValues,
      classUnit: this.classUnit,
    };
  }
}
